// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2oZxi","label":"Completed_label__1Nw15"};